import React from 'react'
import { Grid, Checkbox, Dropdown, Segment } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import Labels from './../../../../common/Labels'
import diamond from '../../../../../images/grafix-icon/diamond.svg'
import SingleLineEditText from '../../../../common/SingleLineEditText';
import MultiLineEditText from '../../../../common/MultiLineEditText';
import SmartIntegration from '../SmartIntegration/SmartIntegration';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Activity Details Card')
    }
})

class PracticeFlowResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            milestone: false,
            buttonPressed:false

            
        }
        this.updateActivityData = this.updateActivityData.bind(this);
    }

    updateActivityData(data) {
        switch (data.target.name) {
            case 'duration':
                this.props.selectedPracticeFlowActivity.duration = data.target.value;
                dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
                break;
        }
    }

    setMilestone(data, value) {
        if (value) {
            this.setState({ 'milestone': value.checked });
            this.props.selectedPracticeFlowActivity.isMilestone = value.checked;
            dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
        }
    }

    saveData = (data) => {
        this.props.selectedPracticeFlowActivity.description = data.text;
        dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
    }

    saveName = (data) => {
        this.props.selectedPracticeFlowActivity.name = data.text;
        dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
    }
    

    toggleButttonPressed = ()=>{
        this.setState({buttonPressed:true})
    }


    render() {
       
        const errorLabel = <div className="customErrorLabel" />;

        const duration = () => {
            if (this.props.status === 0 && this.props.selectedPracticeFlowActivity.isLeafNode) {
                return (
                    <Grid>
                        <Grid.Column width={8}>
                            <Form>
                                <Form.Input
                                    name="duration"
                                    label="Duration"
                                    id="duration"
                                    value={this.props.selectedPracticeFlowActivity.duration}
                                    errorLabel={errorLabel}
                                    disabled={this.props.status !== 0}
                                    onBlur={(event) => this.updateActivityData(event)}
                                    onKeyDown={this.keyPress}
                                    validations={{ matchRegexp: new RegExp(/^((?!(0))[0-9]{1,3})$/) }}
                                    validationErrors={{
                                        matchRegexp: 'Activity duration should range from 1 to 999',
                                    }}
                                    instantValidation
                                />
                            </Form>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <div style={{ textAlign: 'right' }}><br />
                                <span>
                                    <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt="milestone" />&nbsp;
                                    <span>Milestone Activity</span>
                                    <Checkbox className='diamond-location'
                                        checked={this.props.selectedPracticeFlowActivity ? this.props.selectedPracticeFlowActivity.isMilestone : this.state.milestone}
                                        onChange={(event, data) => this.setMilestone(event, data)}
                                        disabled={this.props.status !== 0}
                                    />
                                </span>
                            </div>
                        </Grid.Column>
                    </Grid>
                )
            }
        }
        return (
            <Form noValidate
                className="formcyForm"
                ref={ref => this.form = ref}
                onValidSubmit={this.props.onSubmit}>
                <Grid >

                
                     

                     
               <Grid.Row>
                        <Grid.Column >
                            {this.props.status === 0 ?
                                <SingleLineEditText
                                    name="Name"
                                    text={this.props.selectedPracticeFlowActivity.name}
                                    type="text"
                                    onSaveClick={this.saveName}
                                /> :
                                <Labels
                                    name="Description"
                                    text={this.props.selectedPracticeFlowActivity.name}
                                />
                            }

                            {this.props.status === 0 ?
                                <MultiLineEditText
                                    name="Description"
                                    text={this.props.selectedPracticeFlowActivity.description ? this.props.selectedPracticeFlowActivity.description : "Description Not Provided"}
                                    type="textarea"
                                    onSaveClick={this.saveData}
                                    htmlView={true}
                                />
                                :
                                <Labels
                                    name="Description"
                                    text={this.props.selectedPracticeFlowActivity.description ? this.props.selectedPracticeFlowActivity.description : "Description Not Provided"}
                                    htmlView={true} />
                            }
                            {this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.activities && this.props.selectedPracticeFlowActivity.activities.length > 0 ? '' : duration()}

                        </Grid.Column>
                    </Grid.Row>
                    {this.props.selectedPracticeFlowActivity &&
                 this.props.selectedPracticeFlowActivity.parentActivity &&
                 !this.props.selectedPracticeFlowActivity.isLeafNode && 
                 this.props.status === 0 &&
              this.props.selectedAccount && this.props.selectedAccount.integrations && 
              this.props.selectedAccount.integrations.length > 0 ? (
                <SmartIntegration
                  selectedAccount={this.props.selectedAccount}
                  selectedPracticeFlowActivity={
                    this.props.selectedPracticeFlowActivity
                  }
                  page="configure"
                  buttonPressed={false}
                  toggleButttonPressed={this.toggleButttonPressed}
                />
              ) : null}
                </Grid>
                
            </Form>
        )
    }
}

export default PracticeFlowResourcePaneForm